import React, { Component } from 'react';
import CashRegisterList from './CashRegisterList';
import CashRegisterSave from './CashRegisterSave';
import WithRouter from 'custom/withRouter';

// TODO: Write some comments here about what each section is doing
class CashRegisterPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    callListView = () => {
        this.props.navigate("/cashregister");
    }

    callSaveView = () => {
        this.props.navigate("/cashregister/add");
    }

    //This page renders either Product List or Product Save
    render() {
        const p = this.props;
        const cashRegisterId = p.params.id;
        const isSave = cashRegisterId || p.location.pathname === "/cashregister/add";


        return (
            <React.Fragment>
                {
                    isSave
                        ?
                        <CashRegisterSave
                            name="cashRegisterSave"
                            params={p.params}
                            isDialog={false}
                            callListView={this.callListView}
                            title="Cash Register Info" />
                        :
                        <CashRegisterList onTouchTap={this.callSaveView} title="List of Cash Register" />

                }
            </React.Fragment>
        );
    }
}

export default WithRouter(CashRegisterPage);
